export const GRAD_YEAR_MIN_OFFSET = -8;
export const GRAD_YEAR_MAX_OFFSET = 5;

export function getValidGradYearRange() {
  const currentYear = new Date().getFullYear();

  return {
    min: currentYear + GRAD_YEAR_MIN_OFFSET,
    max: currentYear + GRAD_YEAR_MAX_OFFSET,
  };
}

export function partitionAthletesByGradYear(athletes) {
  const { min, max } = getValidGradYearRange();
  const valid = [];
  const invalid = [];

  for (const athlete of athletes) {
    const gradYear = parseInt(athlete.gradYear, 10);
    if (!isNaN(gradYear) && (gradYear < min || gradYear > max)) {
      invalid.push(athlete);
    } else {
      valid.push(athlete);
    }
  }

  return { valid, invalid };
}
